<template>
  <v-container fluid>
    <v-row v-if="is_tester">
      <DialogVT />
    </v-row>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-row>
          <v-col cols="12" md="6" class="titleLight--text text-h6 pt-4">{{ $t("views.Assets.pageTitle") }} </v-col>
          <v-col cols="12" md="2" class="text-right">
            <v-checkbox
              class="pl-12"
              dense
              @change="update_device_list()"
              v-model="include_installed"
              :label="only_installed_label"
          /></v-col>
          <v-col cols="12" md="4" class="caption">
            <InputSelectVT
              height="32"
              :items="page_content.devices_overview_select"
              @value_changes="get_device_overview($event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" md="4" class="pr-md-3 pb-3 pb-md-0 pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.devices_overview_data && message_type_data"
            :title="page_content.capacity_problems.title"
            :tooltip="page_content.capacity_problems.tooltip"
            :chartData="message_type_data"
            @on-click="apply_graph_filter('MaxUtilisation', $event)"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="4" class="pr-md-3 pb-3 pb-md-0 pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.devices_overview_data && imbalance_problems"
            :tooltip="page_content.imbalance_problems.tooltip"
            :title="page_content.imbalance_problems.title"
            :chartData="imbalance_problems"
            @on-click="apply_graph_filter('MaxImbalance', $event)"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
        <v-col class="common-card-col" cols="12">
          <div class="position-relative">
            <RadialChartVT
              :v-if="this.devices_overview_data && power_change_problems"
              :title="page_content.power_change_problems.title"
              :tooltip="page_content.power_change_problems.tooltip"
              :chartData="power_change_problems"
              @on-click="apply_graph_filter('PowerChangePerc', $event)"
            />
            <div class="button-overlay" @click="show_more_charts()">
              <v-btn x-small class="ma-2" outlined color="primary">
                <span v-if="!show_more">{{ $t("common.labels.showMore") }}</span
                ><span v-else>{{ $t("common.labels.showLess") }}</span>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-row v-show="show_more" class="common-card-row">
        <v-col cols="12" md="4" class="pr-md-3 pb-3 pb-md-0 pa-0">
          <v-col class="common-card-col" cols="12">
            <RadialChartVT
              :v-if="this.devices_overview_data && battery_status_data"
              :title="page_content.battery_status.title"
              :tooltip="page_content.battery_status.tooltip"
              :chartData="battery_status_data"
              @on-click="apply_graph_filter('LowBattery', $event)"
            />
          </v-col>
        </v-col>
        <v-col cols="12" md="4" class="pr-md-3 pb-3 pb-md-0 pa-0">
          <v-col class="common-card-col" cols="12">
            <RadialChartVT
              :v-if="this.devices_overview_data && connection_status_data"
              :title="page_content.connection_status.title"
              :tooltip="page_content.connection_status.tooltip"
              :chartData="connection_status_data"
              @on-click="apply_graph_filter('DeviceCommsStatus', $event)"
            />
          </v-col>
        </v-col>
        <v-col cols="12" md="4" class="pa-0">
          <v-col class="common-card-col" cols="12">
            <RadialChartVT
              :v-if="this.devices_overview_data && device_status"
              :title="page_content.device_status.title"
              :tooltip="page_content.device_status.tooltip"
              :chartData="device_status"
              @on-click="apply_graph_filter('Issues', $event)"
            />
          </v-col>
        </v-col>
      </v-row>
    </v-expand-transition>
    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col pa-0" cols="12">
        <v-row class="pl-3">
          <v-col cols="8">
            <PrimaryFiltersVT
              :list_filters="page_content.filters.primary"
              @filter_update="filter_list($event)"
              current_tab="All"
            />
          </v-col>
          <v-col cols="4" class="text-right mt-3">
            <SecondaryFiltersVT
              :filters="page_content.filters.secondary"
              @clear_filters="clear_filters"
              @apply_filters="apply_filters($event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <DataTableVT
              :headers="page_content.devices_table"
              :items_list="devices"
              sort_by="MaxUtilisation"
              item_key="DeviceID"
              @rowClick="row_actions($event)"
              @add-to-list="watchlist_update($event)"
              @action="table_actions($event)"
              :loading="is_loading"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        color="backgroundLight"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%">
          <Asset :deviceId="deviceId" v-if="overlay_type == 'details'" />
          <EditAssetDetails
            @cancel="dialog = false"
            @save="update_assets_details($event)"
            :asset_data="asset_data"
            v-if="overlay_type == 'edit'"
          />
        </div>
      </v-card>
    </v-overlay>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-container>
</template>

<script>
import Asset from "../views/Asset";
import DataTableVT from "../components/DataTableVT";
import RadialChartVT from "../components/RadialChartVT";
import InputSelectVT from "../components/InputSelectVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import SecondaryFiltersVT from "../components/SecondaryFiltersVT";
import DialogVT from "../components/DialogVT";
import EditAssetDetails from "../components/EditAssetDetails";
import { axios_get, axios_post, axios_delete } from "../services/vt_service";
import { trafo } from "../services/powerdata";
import { watchlist } from "../services/common";
import { content } from "../../config/assets.js";
import { redirect_to_asset } from "../helpers/helpers";

export default {
  name: "Assets",
  components: {
    Asset,
    DataTableVT,
    RadialChartVT,
    InputSelectVT,
    PrimaryFiltersVT,
    SecondaryFiltersVT,
    EditAssetDetails,
    DialogVT,
  },
  data: function () {
    return {
      only_installed_label: this.$t("common.labels.onlyInstalled"),
      filter_conditions: {},
      primary_filter_conditions: "",
      deviceId: null,
      dialog: false,
      search: "",
      page_content: null,
      network_error: false,
      devices: [],
      error_message: "",
      items: ["Today", "This Week", "This Month"],
      devices_overview_data: null,
      watchlist: [],
      include_installed: true,
      filter_communicated: "",
      duration: "1",
      overlay_type: "",
      asset_data: null,
      snackbar: false,
      show_more: false,
      is_loading: false,
      powerdata_type: null,
    };
  },
  created() {
    this.page_content = content;
  },
  async mounted() {
    this.get_device_overview("1");
    this.get_device_list();
    this.$store.commit("update_page_title", "Net Zero");
    await this.$store.dispatch("fetchPowerdataType");
    this.powerdata_type = this.$store.getters.getPowerDataType;
  },
  filters: {},
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    async update_assets_details(data) {
      this.dialog = false;
      this.network_error = false;
      const { DeviceID } = data;
      const {
        DeviceName,
        AssetID,
        SerialNumber,
        PowerRating,
        Latitude,
        Longitude,
        DeviceType,
        Comment,
        InstallationDate,
        IsCommuterArea,
        DeviceVoltage,
        ConnectedMPRNs,
      } = data;
      await axios_get(trafo.update_assets_details, { DeviceID }, data);
      this.error_message = "Device Details Successfully Saved!";
      this.devices = this.devices.map((elem) => {
        if (elem.DeviceID == data.DeviceID) {
          elem = {
            ...elem,
            DeviceName,
            AssetID,
            SerialNumber,
            PowerRating,
            Latitude,
            Longitude,
            DeviceType,
            Comment,
            InstallationDate,
            IsCommuterArea,
            DeviceVoltage,
            ConnectedMPRNs,
          };
          if (data.InstallationStatus) {
            elem.InstallationStatus = data.InstallationStatus;
          }
        }
        return elem;
      });
      this.snackbar = true;
    },
    apply_graph_filter(type, val) {
      this.filter_conditions["inputs"] = {};
      this.filter_conditions["flags"] = {};
      this.filter_conditions["range"] = {};
      if (type == "DeviceCommsStatus") {
        this.filter_conditions["inputs"] = {};
        if (val) {
          this.filter_conditions["inputs"] = this.filter_conditions["inputs"] || {};
          let temp = null;
          if (type == "DeviceCommsStatus") {
            temp = val.toLowerCase().includes("missed")
              ? "Missed Messages"
              : val.toLowerCase().includes("no")
                ? "No Communications"
                : "Good";
          }
          this.filter_conditions["inputs"][type] = temp;
        } else if (this.filter_conditions["inputs"]) {
          delete this.filter_conditions["inputs"].type;
        }
        this.filter_list("All");
      } else if (type == "MaxUtilisation" || type == "PowerChangePerc" || type == "MaxImbalance") {
        if (val) {
          this.filter_conditions["range"] = this.filter_conditions["range"] || {};
          let min = 0,
            max = 0;
          if (type == "MaxUtilisation") {
            min = val.toLowerCase().includes("over") ? 86 : val.toLowerCase().includes("under") ? 0 : 15;
            max = val.toLowerCase().includes("over") ? 0 : val.toLowerCase().includes("under") ? 14 : 85;
          } else if (type == "MaxImbalance") {
            max = val.toLowerCase().includes("imbalance") ? 0 : 90;
            min = val.toLowerCase().includes("imbalance") ? 90 : 0;
          } else if (type == "PowerChangePerc") {
            max = val.toLowerCase().includes("abnormal") ? 0 : 25;
            min = val.toLowerCase().includes("abnormal") ? 25 : 0;
          }
          this.filter_conditions["range"][`${type}_max`] = max;
          this.filter_conditions["range"][`${type}_min`] = min;
        } else if (this.filter_conditions["range"]) {
          delete this.filter_conditions["range"][`${type}_max`];
          delete this.filter_conditions["range"][`${type}_min`];
        }

        this.filter_list("All");
      } else {
        if (val) {
          this.filter_conditions["flags"] = {};
          this.filter_conditions["inputs"] = {};
          let temp = null;
          if (type == "Issues") {
            this.page_content.device_status.data.map((elem) => {
              if (elem.label == val) {
                temp = elem.fields;
              }
            });
            temp.map((elem) => {
              if (val.toLowerCase().includes("no issue")) {
                this.filter_conditions["inputs"] = {};
                this.filter_conditions["inputs"][elem] = `0000000000`;
              } else {
                this.filter_conditions["flags"][elem] = true;
              }
            });
          } else {
            this.filter_conditions["flags"][type] = val && val.toLowerCase().includes("low") ? true : false;
          }
        } else if (this.filter_conditions["flags"]) {
          delete this.filter_conditions["flags"].type;
        }
        this.filter_list("All");
      }
    },
    table_actions(assets_obj) {
      if (assets_obj.action === "OpenAsAPage") {
        redirect_to_asset(this.$router, "asset", assets_obj.item.DeviceID);
      }
      if (assets_obj.action === "EditDetails") {
        this.asset_data = assets_obj;
        this.overlay_type = "edit";
        this.dialog = true;
      }
    },
    apply_filters: function (filters) {
      this.filter_conditions = filters;
      this.filter_list("All");
    },
    clear_filters: function () {
      this.filter_conditions = {};
      this.filter_list("All");
    },
    batteryIndicator(batteryStatus) {
      return batteryStatus == "High"
        ? "success--text"
        : batteryStatus == "Medium"
          ? "secondary--text"
          : batteryStatus == "Low"
            ? "error--text"
            : "primarGrey--text";
    },
    row_actions(item) {
      if (item.ctrlKey) {
        redirect_to_asset(this.$router, "asset", item.DeviceID);
        return;
      }
      this.overlay_type = "details";
      this.deviceId = item.DeviceID;
      this.dialog = true;
    },
    watchlist_update(item) {
      item["IsWatchlisted"] ? this.delete_from_watchlist(item) : this.add_to_watchlist(item);
    },
    update_device_list() {
      this.get_device_overview("1");
      this.filter_list("All");
    },
    show_more_charts() {
      if (!this.show_more) {
        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      }
      this.show_more = !this.show_more;
    },
    async filter_list(filter) {
      this.is_loading = true;
      this.current_tab = filter;
      if (filter) this.primary_filter_conditions = filter;
      let params = {};
      const keys =
        (this.filter_conditions &&
          this.filter_conditions.checkbox &&
          Object.keys(this.filter_conditions["checkbox"])) ||
        [];
      keys.forEach((key) => {
        if (this.filter_conditions["checkbox"][key]) params[key] = this.filter_conditions["checkbox"][key].toString();
      });
      var fil = [];
      this.page_content.filters.primary.map((elem) => {
        elem.value == filter;
        fil.push(filter);
      });

      this.network_error = false;
      params = params ? { params } : {};
      if (this.include_installed) params["only_installed"] = 1;
      const response = await axios_get(trafo.get_assets_data, { num_days: 1 }, params);
      let range_filter = {};
      let range_keys =
        this.filter_conditions && this.filter_conditions["range"] && Object.keys(this.filter_conditions["range"]);
      for (let i = 0; i < (range_keys && range_keys.length) || 0; i++) {
        let temp = range_keys[i].split("_");
        let field = temp[1];
        range_filter[temp[0]] = range_filter[temp[0]] || {};
        range_filter[temp[0]][field] =
          temp[0] == "FlowRate"
            ? this.filter_conditions["range"][range_keys[i]] / 100
            : this.filter_conditions["range"][range_keys[i]];
      }
      this.devices = response
        .map((elem) => {
          elem.IsWatchlisted = this.watchlist.indexOf(elem.DeviceID) != -1 ? true : false;
          return elem;
        })
        .filter((elem) => {
          return (fil.indexOf("Watchlist") != -1 && elem.IsWatchlisted == true) || fil.indexOf("All") != -1;
        })
        .filter((elem) => {
          let last_message_time = elem.LastMessageTime && new Date(elem.LastMessageTime);
          let today = new Date();
          let delta = Math.abs(today - last_message_time) / 1000;
          let hours = delta / 3600;
          return (
            (this.filter_communicated &&
              this.filter_communicated.toLowerCase().includes("no") &&
              hours >= 24 * parseInt(this.duration)) ||
            (this.filter_communicated &&
              this.filter_communicated.toLowerCase().includes("missed") &&
              hours < 24 * parseInt(this.duration) &&
              elem.HasMissedMessages) ||
            (this.filter_communicated &&
              !this.filter_communicated.toLowerCase().includes("no") &&
              !this.filter_communicated.toLowerCase().includes("missed") &&
              hours < 24 * parseInt(this.duration) &&
              !elem.HasMissedMessages) ||
            (!this.filter_communicated && true)
          );
        })
        .filter((elem) => {
          let filtered = true;
          let filter = Object.keys(range_filter);
          for (let i = 0; i < filter.length; i++) {
            if (!(range_filter[filter[i]]["min"] == 0 && range_filter[filter[i]]["max"] == 0))
              if (range_filter[filter[i]]["min"] == 0) {
                filtered = filtered && elem[filter[i]] <= range_filter[filter[i]]["max"];
              } else if (range_filter[filter[i]]["max"] == 0) {
                filtered = filtered && elem[filter[i]] >= range_filter[filter[i]]["min"];
              } else {
                filtered =
                  filtered &&
                  elem[filter[i]] >= range_filter[filter[i]]["min"] &&
                  elem[filter[i]] <= range_filter[filter[i]]["max"];
              }
          }
          filter =
            this.filter_conditions && this.filter_conditions["flags"]
              ? Object.keys(this.filter_conditions["flags"])
              : [];
          for (let i = 0; i < filter.length; i++) {
            if (this.filter_conditions["flags"][filter[i]]) filtered = filtered && elem[filter[i]];
          }
          return filtered;
        })
        .filter((elem) => {
          let filtered = true;
          this.filter_conditions &&
            this.filter_conditions["inputs"] &&
            Object.keys(this.filter_conditions["inputs"]).map((e) => {
              filtered = filtered && elem[e] == this.filter_conditions["inputs"][e];
            });
          return filtered;
        });
      this.is_loading = false;
    },
    async add_to_watchlist(item) {
      var data = { DeviceID: item["DeviceID"] };
      this.network_error = false;
      await axios_post(watchlist.add_to_watchlist, data);
      item["IsWatchlisted"] = true;
      this.watchlist.push(item["DeviceID"]);
    },
    async delete_from_watchlist(item) {
      var data = { DeviceID: item["DeviceID"] };
      this.network_error = false;
      await axios_delete(watchlist.delete_from_watchlist, {}, data);
      this.watchlist.splice(this.watchlist.indexOf(item["DeviceID"]), 1);
      item["IsWatchlisted"] = false;
    },
    async get_device_overview(duration) {
      this.duration = duration;
      this.network_error = false;
      let params = this.include_installed ? { only_installed: 1 } : {};
      const response = await axios_get(trafo.get_assets_overview, { duration }, params);
      this.devices_overview_data = response;
    },
    async get_device_list() {
      this.is_loading = true;
      this.network_error = false;
      let params = {};
      if (this.include_installed) params["only_installed"] = 1;
      let num_days = this.duration ? parseInt(this.duration) : 1;
      const response = await axios_get(trafo.get_assets_data, { num_days });
      this.get_watchlisted_devices(response);
      this.is_loading = false;
    },
    async get_watchlisted_devices(devices) {
      this.network_error = false;
      const response = await axios_get(watchlist.get_device_watchlist);
      this.watchlist =
        response &&
        response.map((elem) => {
          return elem["DeviceID"];
        });
      this.devices = devices.map((elem) => {
        elem.IsWatchlisted = this.watchlist.indexOf(elem.DeviceID) != -1 ? true : false;
        return elem;
      });
    },
    format_chart_data(chart_data, config) {
      var data = [];
      var others_total = 0;
      if (chart_data) {
        data = config.data.map((currentValue) => {
          others_total = 0;
          var total = 0;
          var result = chart_data.filter((data) => {
            total = total + data.Total;
            if (
              data.name &&
              !currentValue.values &&
              data.name.toLowerCase().trim() == currentValue.value.toLowerCase().trim()
            ) {
              return true;
            } else if (data.name && !currentValue.value && currentValue.values) {
              others_total =
                others_total +
                (data.name && currentValue.values.indexOf(data.name.toLowerCase()) == -1 ? data.Total : 0);
              return true;
            } else {
              return false;
            }
          });
          var value = result[0] && result[0]["Total"];
          var final_val = currentValue.label == "Others" ? others_total : value;
          return [
            currentValue.label,
            final_val,
            {
              msg: currentValue.msg,
              title: currentValue.label,
              footer: `${this.$numberWithCommas(final_val)}(${this.$numberWithCommas(
                Math.round((final_val / total) * 10000) / 100
              )}%)`,
            },
          ];
        });
      } else {
        data = [config.header];
      }
      return data ? [config.header, ...data] : null;
    },
  },
  computed: {
    is_tester: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("Tester") != -1 ? true : false;
    },
    user_account: function () {
      return this.$auth.user;
    },
    battery_status_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.batteryStatus, this.page_content.battery_status)
        : [];
    },
    connection_status_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.connectionStatus, this.page_content.connection_status)
        : [];
    },
    message_type_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.capacityProblems, this.page_content.capacity_problems)
        : [];
    },
    device_status: function () {
      let temp = [];
      let temp2 = 0;
      if (this.devices_overview_data) {
        this.devices_overview_data["deviceStatus"].map((elem) => {
          if (
            elem.name == "HasTempSenseProblem" ||
            elem.name == "HasTempOverLimitProblem" ||
            elem.name == "HasTemperatureOutsideRangeProblem"
          ) {
            temp2 = temp2 + elem.Total;
          } else {
            temp.push(elem);
          }
        });
        // temp.push({ Total: temp2, name: "HasTempProblem" });
        this.format_chart_data(temp, this.page_content.device_status);
      }
      return temp.length > 0 ? this.format_chart_data(temp, this.page_content.device_status) : [];
    },
    imbalance_problems: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.imbalanceProblems, this.page_content.imbalance_problems)
        : [];
    },
    power_change_problems: function () {
      return this.devices_overview_data
        ? this.format_chart_data(
            this.devices_overview_data.powerChangeProblems,
            this.page_content.power_change_problems
          )
        : [];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .right-border {
  // border-right: none;
  border-right: 1px solid var(--v-border-base);
}

::v-deep .fxd-height {
  min-height: 50px;
  align-items: flex-start;
}

::v-deep .v-overlay {
  opacity: 0;
  max-height: 0;
  transition: all 0.15s ease;
}

::v-deep .v-overlay.v-overlay--active {
  opacity: 1;
  max-height: 100vh;
  transition: all 0.75s ease;
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.position-relative {
  position: relative;
}

.button-overlay {
  position: absolute;
  top: 10%;
  left: 90%;
  transform: translate(-50%, -50%);
}
</style>
